import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import Form from 'core/forms/Form';

import Field from 'core/forms/Field';
import Button from 'common/components/Button';
import SelectComponent from './SelectComponent';

import { localeStrings as strings } from 'applicationConfig';

@inject('dataSelectStore')
@observer
class DataSelectForm extends Component {
  constructor(props) {
    super(props);

    this.onFormSubmit = this.onFormSubmit.bind(this);
  }

  onFormSubmit(values) {
    return this.props.onSubmit(values);
  }

  render() {
    const { segmentMicsCount, orderTypeCount } = this.props.dataSelectStore;
    const showSegmentMics = segmentMicsCount > 1;
    const showOrderTypes = orderTypeCount > 1;

    return (
      <Form onSubmit={this.onFormSubmit} formStore={this.props.formStore}>
        <div className="field-group">
          <div className="field-group-label">{strings.dataSelect.lblOrdersTrades}</div>
          <div className="field-group-value">
            <Field
              component={SelectComponent}
              name="datatype"
              optionsName="orderTrades"
              disableOnEmpty={false}
              loadingFlagName="isOrderTradeLoading"
            />
          </div>
        </div>
        <div className="field-group">
          <div className="field-group-label">{strings.dataSelect.lblTradingVenues}</div>
          <div className="field-group-value">
            <Field
              component={SelectComponent}
              name="tv"
              optionsName="tvs"
              disableOnEmpty={true}
              loadingFlagName="isTvLoading"
            />
          </div>
        </div>
        <div className="field-group">
          <div className="field-group-label">{strings.dataSelect.lblAssetClasses}</div>
          <div className="field-group-value">
            <Field
              component={SelectComponent}
              name="assetclass"
              optionsName="assetClasses"
              disableOnEmpty={true}
              loadingFlagName="isAssetClassesLoading"
            />
          </div>
        </div>
        <div className="field-group">
          <div className="field-group-label">{strings.dataSelect.lblSubAssetClasses}</div>
          <div className="field-group-value">
            <Field
              component={SelectComponent}
              name="subassetclass"
              optionsName="subAssetClasses"
              disableOnEmpty={true}
              loadingFlagName="isSubAssetClassesLoading"
            />
          </div>
        </div>
        <div className="field-group">
          <div className="field-group-label">{strings.dataSelect.lblInstruments}</div>
          <div className="field-group-value">
            <Field
              component={SelectComponent}
              name="instrument"
              optionsName="instruments"
              disableOnEmpty={true}
              loadingFlagName="isInstrumentsLoading"
            />
          </div>
        </div>

          <div className={`field-group ${showSegmentMics ? '' : 'hidden'}`}>
            <div className="field-group-label">{strings.dataSelect.lblSegmentMic}</div>
            <div className="field-group-value">
              <Field
                component={SelectComponent}
                name="instrumentmic"
                optionsName="segmentMics"
                disableOnEmpty={true}
                loadingFlagName="areSegmentMicsLoading"
              />
            </div>
          </div>

          <div className={`field-group ${showOrderTypes ? '' : 'hidden'}`}>
            <div className="field-group-label">{strings.dataSelect.lblOrderType}</div>
            <div className="field-group-value">
              <Field
                component={SelectComponent}
                name="ordertype"
                optionsName="orderType"
                disableOnEmpty={true}
                loadingFlagName="areOrderTypesLoading"
              />
            </div>
          </div>

        <div className="actions">
          <Button
            className="btn btn-primary"
            type="submit"
            disabled={
                !this.props.formStore.isValid
                || this.props.dataSelectStore.isUpdating
                || this.props.formStore.isFormSubmitted
                || (showSegmentMics && this.props.formStore.values.instrumentmic == null)
                || (showOrderTypes && this.props.formStore.values.ordertype == null)
                || this.props.dataSelectStore.isSegmentMicLoadingFailed
            }
          >
            <span className="button-caption">{strings.generic.submit}</span>
          </Button>
        </div>
      </Form>
    );
  }
}

export default DataSelectForm;



// WEBPACK FOOTER //
// ./src/containers/DataSelect/DataSelectForm.jsx